import { Center, Loader } from '@mantine/core';
import { Navigate } from 'react-router-dom';
import { useAuth, isFinancialLayoutRole } from '../auth/AuthProvider';
import { FinancialLayout } from './FinancialLayout';
import { ParentLayout } from './ParentLayout';

/**
 * Role-adaptív layout választó.
 *  - Loading közben spinner.
 *  - Nincs user → /login.
 *  - pta_cashier / pta_leader → FinancialLayout (sidebar).
 *  - minden más role → ParentLayout (top-nav).
 */
export function RoleAdaptiveLayout() {
  const { loading, user, activeRole } = useAuth();

  if (loading) {
    return (
      <Center h="100vh">
        <Loader />
      </Center>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  return isFinancialLayoutRole(activeRole) ? <FinancialLayout /> : <ParentLayout />;
}
